import { combineReducers } from 'redux';
import { groupsReducer } from './Groups/reducer';

export const profilesReducer = combineReducers({
    groups: groupsReducer
});
